module.exports = __webpack_public_path__ + "img/logo-billo-work.e5f0cd36.svg";